//import React from 'react';
//import Top from '../components/Top';
import { Spinner } from 'react-bootstrap';
import { useQuery } from '@tanstack/react-query';
import parse, { domToReact } from 'html-react-parser';
import { API_BASE_URL } from "../api/config";
//import styles from '../style.module.css';

function Terms() {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: ['terms'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/user/pages/terms`);
      return await res.json();
    },
  })


  const options = {
    replace({ attribs, children }) {
      if (!attribs) {
        return;
      }

      if (attribs?.classname === "{styles.headerText4}") {
        return (
          <h3 className='headerText4'>
            {domToReact(children, options)}
          </h3>
        );
      }
      if (attribs?.classname === "{styles.terms}") {
        return (
          <div className='terms'>
            {domToReact(children, options)}
          </div>
        );
      }
      if (attribs?.classname === "{`container") {
        return (
          <div className='container termsContent'>
            {domToReact(children, options)}
          </div>
        );
      }
    }

  }
  if (isLoading) {
    return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
      <Spinner animation="border" role="status" style={{ height: "89px", width: "89px" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Kindly be patient while we fetch your data</p>
    </div>
  }

  if (isError) {
    return (
      <p>An Error Occurred : {error.message}</p>
    )
  }

  return (

    <div className="terms">
      <div className="container termsContent">
        <div className="row">
          <div className="col-12">
            <h3 className="headerText4">{data?.title}</h3>

            {parse(data?.content, options)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Terms;
